import { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { Col, H4, Text, Row } from '@metaicg/sensei-ui';
import Breadcrumbs, { BreadcrumbsData } from '@/shared/templates/dashboard-page/components/breadcrumb';
import styles from './styles';
import useRefreshToken from '@/features/auth/hooks/use-refresh-token';
import { ACCESS_TOKEN_DURATION } from '@/features/auth/constants';
import { LayoutWrapper } from '@/shared/components/layout';
import AnimatedPage from '@/shared/components/layout/components/animated-page';

type BasicPageProps = PropsWithChildren<{
  title: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbsData;
  toolbarContent?: ReactNode;
}>;

const BreadcrumbContainer = styled.div(styles.breadcrumb);
const TitleContainer = styled(Row)(styles.title);
const Content = styled.div(styles.content);
const Toolbar = styled(Row)(styles.toolbar);

const BasicPage = (props: BasicPageProps) => {
  const { title, subtitle, breadcrumbs, children, toolbarContent } = props;
  useRefreshToken({
    interval: ACCESS_TOKEN_DURATION,
  });

  return (
    <AnimatedPage>
      <LayoutWrapper>
        <Row justify="center">
          <Col xs={24} md={toolbarContent ? 12 : 24}>
            {breadcrumbs && (
              <BreadcrumbContainer>
                <Breadcrumbs data={breadcrumbs} />
              </BreadcrumbContainer>
            )}
            {title && (
              <TitleContainer>
                <Row>
                  <Col flex="100%">
                    <H4 color="neutral.palette100">{title}</H4>
                  </Col>
                  <Col flex="100%">
                    <Text as="p" weight="normal" color="neutral.palette300" size="md">
                      {subtitle}
                    </Text>
                  </Col>
                </Row>
              </TitleContainer>
            )}
          </Col>
          {toolbarContent && (
            <Col xs={24} md={12}>
              <Toolbar justify="end" align="middle" gutter={[16, 16]}>
                <Col>{toolbarContent}</Col>
              </Toolbar>
            </Col>
          )}
        </Row>
        <Content>{children}</Content>
      </LayoutWrapper>
    </AnimatedPage>
  );
};

export default BasicPage;
